// extracted by mini-css-extract-plugin
module.exports = {"card":"ProgramCard_card__yW1Z1","arrow":"ProgramCard_arrow__2gR1l"};